import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { buildWorkOrderUpdatePayload } from '#/api/momMgmt/workOrder/serializeWorkOrderWrite';

export async function updateWorkOrder(id, values) {
  const { data: raw } = await request.patch(
    `/mom/work-order/${id}`,
    keysToSnake(buildWorkOrderUpdatePayload(values)),
  );
  return parseVer4DetailResponse(raw);
}
